<template>
  <div class="firmware px">
    <c-mouse-am35-electricity
      ref="am35FirmwareElectricity"
      :showBattery="false"
      :showLab="true"
      :sn="MouseSn || ''"
    />
    <c-password
      @select="localFirmware"
      :onBack="
        () => {
          resumeAM35BatteryGuard('firmwarePassword', { refresh: true, force: true });
          passwordVisible = false;
          type = '';
        }
      "
      v-if="passwordVisible"
    />
    <template v-else>
      <img class="logo" :src="images.logo_white" />
      <template v-if="isDongleConnect">
        <div class="title device-mouse">
          <div class="device-name">{{ $t("mouse.name") }}</div>
          <span class="device-note"></span>
          <a-popover
            placement="top"
            trigger="click"
            :content="$t('mouse.connect', [$t('mouse.name')])"
          >
            <div class="code">
              <span class="version-label"></span>
              {{ mouseVersion }}
              <span v-if="mouseifNew" class="new-tag">{{ isCN ? "新" : "NEW" }}</span>
              <span class="dongle-only-note">（通过Dongle无法升级）</span>
            </div>
          </a-popover>
        </div>
        <div class="title device-dongle">
          <div class="device-name">Dongle</div>
          <span class="device-note"></span>
          <div class="code" @click="showPassword('dongle')">
            <span class="version-label"></span>
            {{ dongleVersion }}
            <span v-if="dongleifNew" class="new-tag">{{ isCN ? "新" : "NEW" }}</span>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="title device-mouse">
          <div class="device-name">{{ $t("mouse.name") }}</div>
          <span class="device-note warn">{{ $t("mouse.connect", [" Dongle "]) }}</span>
          <div class="code" @click="showPassword('mouse')">
            <span class="version-label"></span>
            {{ mouseVersion }}
            <span v-if="mouseifNew" class="new-tag">{{ isCN ? "新" : "NEW" }}</span>
          </div>
        </div>
      </template>
      <div class="button" @click="updateFirmware" :class="{ disabled: !hasNew }">
        {{ $t("loader.update") }}
      </div>
      <div class="tip" v-html="$t('mouse.updateTip')"></div>
    </template>
    <c-progress
      v-if="percent >= 0 && percent <= 100"
      :percent="percent"
      :text="progressText"
      :image="images[deviceImage]"
      @close="goBackAfterUpgrade"
    />
    <!-- 固件升级确认弹窗 -->
    <firmware-update-modal
      v-model="updateConfirmVisible"
      :is-wired-connected="isWiredConnected"
      :is-dongle-connected="isDongleConnectedForUpdate"
      :mouse-version="mouseVersion"
      :mouseif-new="mouseifNew"
      :dongle-version="dongleVersion"
      :dongleif-new="dongleifNew"
      @confirm="confirmUpdate"
      @cancel="cancelUpdate"
    />
  </div>
</template>
<script>
import { mapState } from "vuex";
import { download } from "@/utils";
import { deviceCallbackManager } from '@/utils/DeviceCallbackManager';
import { parseAM35SN, getAM35DeviceImageKey } from "@/utils/businessUtils";
import FirmwareUpdateModal from "@/components/FirmwareUpdateModal.vue";

export default {
  components: {
    FirmwareUpdateModal,
  },
  data() {
    return {
      percent: -1,
      progressText: "",
      type: "mouse",
      passwordVisible: false,
      mouseVersion: "",
      mouseifNew: false,
      MouseSn: "",
      dongleVersion: "",
      dongleifNew: false,
      isDongleConnect: false,
      // 固件升级确认弹窗
      updateConfirmVisible: false,
      isWiredConnected: false, // 有线连接状态（鼠标USB直连）
      isDongleConnectedForUpdate: false, // Dongle连接状态（Dongle USB连接）
      // 分别记录两个设备的更新进度
      mouseUpdateProgress: -1,
      dongleUpdateProgress: -1,
      // 设备状态轮询定时器
      deviceStatusPollingTimer: null,
      // 更新失败标志位
      updateFailed: false,
    };
  },
  computed: {
    ...mapState("assets", {
      images: "images",
    }),
    ...mapState("app", {
      isCN: "isCN",
      isTest: "isTest",
    }),
    ...mapState("loader", {
      isQT: "isQT",
      isWeb: "isWeb",
      systemInfo: "systemInfo",
    }),
    ...mapState("mouse", {
      driverVersion: "version",
    }),
    hasNew() {
      // 根据连接状态判断是否有新版本
      if (this.isDongleConnect) {
        // dongle连接时，只能更新dongle，无论mouse是否有new都不能通过dongle升级
        return this.dongleifNew;
      } else {
        // 直连时，只能更新mouse
        return this.mouseifNew;
      }
    },
    // 获取当前应该更新的设备类型
    updateType() {
      if (this.isDongleConnect) {
        return "dongle";
      } else {
        return "mouse";
      }
    },
    deviceImage() {
      // if (this.isDongleConnect) {
      //   return getAM35DeviceImageKey(parseAM35SN(this.MouseSn),true);
      // } else {
      //   return getAM35DeviceImageKey(parseAM35SN(this.MouseSn));
      // }
      return getAM35DeviceImageKey(parseAM35SN(this.MouseSn), true);
    },
    winUrl() {
      return `https://angrymiao-www.oss-cn-shenzhen.aliyuncs.com/diy/AMasterDriverSetup${
        this.isTest ? "Test" : ""
      }.zip`;
    },
  },
  watch: {
    // 监听弹窗显示状态，控制轮询
    updateConfirmVisible(isVisible) {
      if (isVisible) {
        // 弹窗打开时，立即检查一次并开始轮询
        this.checkConnectionStatus();
        this.startDeviceStatusPolling();
      } else {
        // 弹窗关闭时，停止轮询
        this.stopDeviceStatusPolling();
      }
    },
  },
  mounted() {
    this.$store.dispatch("loader/setInLoader", true);
    this.$store.dispatch("loader/getAM35Version");
    this.$store.dispatch("loader/setLoading", true);
    this.subscribeToHostEvents();
  },
  activated() {
    // 确保每次进入页面时弹窗是关闭的
    this.updateConfirmVisible = false;
  },
  beforeDestroy() {
    this.unsubscribeFromHostEvents();
    // 清理轮询定时器
    this.stopDeviceStatusPolling();
    // 确保弹窗状态被重置
    this.updateConfirmVisible = false;
  },
  methods: {
    pauseAM35BatteryGuard(source) {
      const electricity = this.$refs.am35FirmwareElectricity;
      if (!electricity || typeof electricity.pauseBatteryGuard !== "function") {
        console.warn(`AM35 Firmware 电量组件未就绪，无法暂停电量守卫: ${source}`);
        return;
      }
      electricity.pauseBatteryGuard(source);
    },
    resumeAM35BatteryGuard(source, options = {}) {
      const electricity = this.$refs.am35FirmwareElectricity;
      if (!electricity || typeof electricity.resumeBatteryGuard !== "function") {
        console.warn(`AM35 Firmware 电量组件未就绪，无法恢复电量守卫: ${source}`);
        return;
      }
      electricity.resumeBatteryGuard(source, options);
    },
    updateFirmware() {
      if (!this.hasNew) return;

      // 重置失败标志（用户重新点击更新按钮时）
      this.updateFailed = false;
      if (!this.canUpdateAM35Firmware()) {
        this.showVersionConfirm();
        return;
      }
      
      // 显示弹窗（watch 会自动触发轮询）
      this.updateConfirmVisible = true;
    },
    // 检查连接状态
    checkConnectionStatus() {
      // 通过 Bridge 下发检查设备连接状态指令
      // 设备会通过 updateDevicesStatus 事件上报状态
      this.$store.dispatch("loader/checkDeviceStatus");
    },
    // 开始设备状态轮询
    startDeviceStatusPolling() {
      // 清理旧的定时器（防止重复创建）
      this.stopDeviceStatusPolling();
      
      // 每2.5秒轮询一次设备状态
      this.deviceStatusPollingTimer = setInterval(() => {
        this.checkConnectionStatus();
      }, 2500);
      
      console.log("开始设备状态轮询 (间隔: 2.5秒)");
    },
    // 停止设备状态轮询
    stopDeviceStatusPolling() {
      if (this.deviceStatusPollingTimer) {
        clearInterval(this.deviceStatusPollingTimer);
        this.deviceStatusPollingTimer = null;
        console.log("停止设备状态轮询");
      }
    },
    // 确认升级
    confirmUpdate() {
      if (this.isWiredConnected && this.isDongleConnectedForUpdate) {
        this.updateConfirmVisible = false;
        this.pauseAM35BatteryGuard("firmwareUpdate");
        // 重置进度和失败标志
        this.mouseUpdateProgress = -1;
        this.dongleUpdateProgress = -1;
        this.updateFailed = false;
        // 触发更新（传参不变，后端会同时更新两个设备）
        this.$store.dispatch("loader/autoAM35update", this.updateType);
      }
    },
    // 取消升级
    cancelUpdate() {
      this.updateConfirmVisible = false;
    },
    canUpdateAM35Firmware() {
      if (this.isQT) {
        return this.compareVersion(this.systemInfo.version, "1.3.6") >= 0;
      }
      return this.compareVersion(this.driverVersion, "1.0.4") > 0;
    },
    showVersionConfirm() {
      const title = this.isQT
        ? this.$t("mouse.am35FirmwareRequireQtVersion")
        : this.$t("mouse.am35FirmwareUseClient");

        this.$info({
          title,
          okText: this.$t("yes"),
          // cancelText: this.$t("cancel"),
          centered: true,
          // onOk: () => {
          //   download(this.winUrl, "AMasterDriverSetup.zip");
          // },
        });
    },
    compareVersion(versionA, versionB) {
      const normalize = (version) =>
        String(version || "")
          .trim()
          .replace(/^[Vv]/, "")
          .split(".")
          .map((part) => {
            const match = part.match(/\d+/);
            return match ? Number(match[0]) : 0;
          });
      const source = normalize(versionA);
      const target = normalize(versionB);
      const maxLength = Math.max(source.length, target.length);
      for (let index = 0; index < maxLength; index += 1) {
        const current = source[index] || 0;
        const expected = target[index] || 0;
        if (current > expected) return 1;
        if (current < expected) return -1;
      }
      return 0;
    },
    showPassword(type) {
      this.pauseAM35BatteryGuard("firmwarePassword");
      this.passwordVisible = true;
      this.type = type;
    },
    localFirmware() {
      this.resumeAM35BatteryGuard("firmwarePassword");
      this.passwordVisible = false;
      this.pauseAM35BatteryGuard("firmwareUpdate");
      this.$store.dispatch("loader/handleAM35update", this.type);
    },

    //升级完成返回
    goBackAfterUpgrade(){
      this.resumeAM35BatteryGuard("firmwareUpdate");
      this.percent = -1;
      this.$router.replace(this.$paths.deviceList);
    },
    subscribeToHostEvents() {
      deviceCallbackManager.subscribe("updatetAM35Version", this.onHostUpdateAM35Version);
      deviceCallbackManager.subscribe("updateFinish", this.onHostUpdateFinish);
      deviceCallbackManager.subscribe('updateMouseProgress', this.onHostUpdateMouseProgress);
      deviceCallbackManager.subscribe("updateDevicesStatus", this.onHostUpdateDevicesStatus);
      deviceCallbackManager.subscribe("update35MouseProgress", this.onHostUpdate35MouseProgress);
      deviceCallbackManager.subscribe("update35DongleProgress", this.onHostUpdate35DongleProgress);
    },
    unsubscribeFromHostEvents() {
      deviceCallbackManager.unsubscribe("updatetAM35Version", this.onHostUpdateAM35Version);
      deviceCallbackManager.unsubscribe("updateFinish", this.onHostUpdateFinish);
      deviceCallbackManager.unsubscribe('updateMouseProgress', this.onHostUpdateMouseProgress);
      deviceCallbackManager.unsubscribe("updateDevicesStatus", this.onHostUpdateDevicesStatus);
      deviceCallbackManager.unsubscribe("update35MouseProgress", this.onHostUpdate35MouseProgress);
      deviceCallbackManager.unsubscribe(
        "update35DongleProgress",
        this.onHostUpdate35DongleProgress
      );
    },
    onHostUpdateAM35Version(json) {
      console.log("Bridge", "updatetAM35Version", "Start", json);
      if (json) {
        const data = JSON.parse(json);
        this.mouseVersion = data.mouseVersion;
        this.mouseifNew = data.mouseifNew;
        this.MouseSn = data.MouseSn ?? "";
        if (
          data &&
          Object.prototype.hasOwnProperty.call(data, "dongleVersion") &&
          Object.prototype.hasOwnProperty.call(data, "dongleifNew")
        ) {
          this.isDongleConnect = true;
          this.dongleVersion = data.dongleVersion ?? "";
          this.dongleifNew = data.dongleifNew ?? false;
        } else {
          this.isDongleConnect = false;
        }
        console.log("Bridge", "updatetAM35Version", "End");
        this.resumeAM35BatteryGuard("firmwareUpdate", { refresh: true, force: true });
        this.$store.dispatch("loader/setLoading", false);
      }
    },
    onHostUpdateFinish() {
      setTimeout(() => {
        this.$store.dispatch("loader/getAM35Version");
      }, 2000);
    },
    onHostUpdateMouseProgress(json) {
      console.log("----------------", new Date().getTime(), "----------------");
      if (json) {
        console.log(json);
        const data = JSON.parse(json);
        this.percent = data.progress;
        this.progressText = (this.isCN ? data.message.zh_CN : data.message.en_US) || "";
        console.log(this.percent);
        if (this.percent >= 100) {
          // this.$store.dispatch("loader/getAM35Version");
        } else if (this.percent === -1) {
          this.$info({
            title: this.$t("loader.failToUpdate"),
            width: "8.4rem",
            okText: this.$t("yes"),
            cancelText: this.$t("cancel"),
            centered: true,
          });
        }
      }
    },
    // 处理设备接入状态上报
    onHostUpdateDevicesStatus(json) {
      console.log("Bridge", "updateDevicesStatus", "Start", json);
      if (json) {
        const data = JSON.parse(json);
        // am35Mouse: 1=已连接, 0=未连接
        // am35Dongle: 1=已连接, 0=未连接
        this.isWiredConnected = data.am35Mouse === 1;
        this.isDongleConnectedForUpdate = data.am35Dongle === 1;
        console.log("Bridge", "updateDevicesStatus", "End", {
          isWiredConnected: this.isWiredConnected,
          isDongleConnectedForUpdate: this.isDongleConnectedForUpdate,
        });
      }
    },
    // 处理鼠标固件更新进度
    onHostUpdate35MouseProgress(json) {
      if (json) {
        const data = JSON.parse(json);
        this.mouseUpdateProgress = data.progress ?? -1;

        console.log("鼠标进度:", this.mouseUpdateProgress);

        // 如果鼠标更新失败，显示提示并标记失败
        if (this.mouseUpdateProgress === -1) {
          this.resumeAM35BatteryGuard("firmwareUpdate", { refresh: true, force: true });
          this.$info({
            title: this.$t("loader.failToUpdate") + " (鼠标)",
            width: "8.4rem",
            okText: this.$t("yes"),
            centered: true,
          });
          // 标记更新失败，阻止后续进度更新
          this.updateFailed = true;
          this.percent = -1;
          this.progressText = "";
          return;
        }

        // 如果已经失败，忽略后续进度上报
        if (this.updateFailed) {
          console.log("更新已失败，忽略鼠标进度上报");
          return;
        }

        // 同步总进度
        this.syncTotalProgress();
      }
    },
    // 处理Dongle固件更新进度
    onHostUpdate35DongleProgress(json) {
      if (json) {
        const data = JSON.parse(json);
        this.dongleUpdateProgress = data.progress ?? -1;

        console.log("Dongle进度:", this.dongleUpdateProgress);

        // 如果Dongle更新失败，显示提示并标记失败
        if (this.dongleUpdateProgress === -1) {
          this.resumeAM35BatteryGuard("firmwareUpdate", { refresh: true, force: true });
          this.$info({
            title: this.$t("loader.failToUpdate") + " (Dongle)",
            width: "8.4rem",
            okText: this.$t("yes"),
            centered: true,
          });
          // 标记更新失败，阻止后续进度更新
          this.updateFailed = true;
          this.percent = -1;
          this.progressText = "";
          return;
        }

        // 如果已经失败，忽略后续进度上报
        if (this.updateFailed) {
          console.log("更新已失败，忽略Dongle进度上报");
          return;
        }

        // 同步总进度
        this.syncTotalProgress();
      }
    },
    // 同步总进度：两个设备都更新时取最小值
    syncTotalProgress() {
      const mouseProgress = this.mouseUpdateProgress;
      const dongleProgress = this.dongleUpdateProgress;

      // 判断哪些设备正在更新（进度 >= 0 表示正在更新或已完成，-1 表示未开始或失败）
      const mouseUpdating = mouseProgress >= 0;
      const dongleUpdating = dongleProgress >= 0;

      if (mouseUpdating && dongleUpdating) {
        // 两个设备都在更新：取最小值（最大交集），确保至少显示1%
        this.percent = Math.max(1, Math.min(mouseProgress, dongleProgress));
      } else if (mouseUpdating || dongleUpdating) {
        // 只有一个设备在更新：显示1%（确保能跳转到进度页面）
        this.percent = 1;
      } else {
        // 都未更新（都是-1）
        this.percent = -1;
        this.progressText = "";
        return;
      }

      // 更新进度文本
      if (this.percent >= 100) {
        this.progressText = this.$t("loader.updateComplete");
        this.onHostUpdateFinish();
      } else {
        this.progressText = `${this.$t("loader.updatingFirmware")} ${this.percent}%`;
      }

      console.log(`总进度: ${this.percent}% (鼠标:${mouseProgress}%, Dongle:${dongleProgress}%)`);
    },
  },
};
</script>
<style lang="scss" scoped>
.firmware {
  font-size: 16px;
  color: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 150px;

  .logo {
    width: 300px;
    height: auto;
    margin-bottom: 30px;
  }

  .title {
    width: 720px;
    font-size: 30px;
    padding: 15px;
    margin-bottom: 20px;
    border-bottom: 1px solid $primary-color;
    display: flex;
    align-items: center;
    position: relative;
    background-color: rgba(20, 20, 20, 0.5);
    border-radius: 10px;

    &.device-mouse {
      border-left: 3px solid $primary-color;
    }

    &.device-dongle {
      border-left: 3px solid $primary-color;
    }

    .device-name {
      font-weight: 500;
      margin-right: 10px;
    }

    .device-note {
      font-size: 16px;
      color: $active-color;
      letter-spacing: 0.5px;
      margin-left: 5px;
      height: 30px;
      line-height: 45px;
      flex: auto;

      &.warn {
        color: $active-color;
      }
    }

    .code {
      flex: none;
      font-size: 22px;
      color: #3c3c3c;
      cursor: pointer;
      display: flex;
      align-items: center;
      gap: 8px;

      .version-label {
        font-size: 16px;
        color: #3c3c3c;
      }

      .new-tag {
        margin-left: 8px;
        background-color: $primary-color;
        color: white;
        font-size: 14px;
        padding: 2px 8px;
        border-radius: 10px;
      }

      .dongle-only-note {
        font-size: 12px;
        color: #666666;
        margin-left: 8px;
      }

      .iconfont {
        font-size: 24px;
        transform: rotate(90deg);
        display: inline-block;
      }
    }
  }

  .mouse-version {
    height: 180px;
    overflow: hidden;
    transition: height 0.56s cubic-bezier(0.52, 0.16, 0.24, 1);
    margin-bottom: 30px;

    &.close {
      height: 0;
    }
  }

  .dongle-version {
    height: 290px;
    overflow: hidden;
    transition: height 0.56s cubic-bezier(0.52, 0.16, 0.24, 1);
    margin-bottom: 30px;

    &.close {
      height: 0;
    }
  }

  .version {
    @include flex-center;
    justify-content: flex-end;
    width: 720px;
    padding: 10px 0;
    border-bottom: 3px solid #1d1d1d;
    font-size: 26px;
    margin-bottom: 40px;

    .name {
      width: 80%;
      flex: auto;
      cursor: pointer;
    }

    .code {
      font-size: 24px;
      color: #3c3c3c;
      flex: none;
      margin-right: 15px;
      cursor: pointer;

      .iconfont {
        font-size: 28px;
      }
    }

    .new {
      width: 56px;
      vertical-align: text-top;
      margin-top: -10px;
    }

    .radio {
      width: 30px;
      height: 30px;
      border: 2px solid #3c3c3c;
      border-radius: 50%;
      padding: 3px;
      margin-right: 30px;
      flex: none;
      cursor: pointer;
      display: none;

      &.active::before {
        width: 100%;
        height: 100%;
        display: block;
        content: "";
        background-color: $primary-color;
        border-radius: 50%;
      }
    }
  }

  .description {
    width: 720px;
    height: 250px;
    word-break: break-all;
    white-space: pre-wrap;
    font-size: 28px;
    overflow-y: auto;
    margin-bottom: 30px;
  }

  .button {
    @include linear-button;
    width: 200px;
    height: 60px;
    line-height: 60px;
    font-size: 28px;

    &.disabled {
      opacity: 0.6;
      cursor: not-allowed;
    }
  }

  .tip {
    height: 28px;
    line-height: 28px;
    font-size: 18px;
    text-align: center;
    margin-top: 40px;
    color: #666666;
  }
}
</style>
